import type { FC } from "react";
import Skeleton from "./Skeleton";

/** Layout-matched placeholder for the lazy-loaded Login view. */
const LoginSkeleton: FC = () => {
  return (
    <div
      className="mx-auto mt-6 flex w-full max-w-150 flex-col items-center"
      aria-busy="true"
      aria-live="polite"
    >
      <span className="sr-only">Loading Rip City Rewards</span>

      <div className="mb-8 flex w-full items-center justify-center">
        <Skeleton className="aspect-[80/29] w-full max-w-70 rounded-md md:max-w-80" />
      </div>

      <div className="w-full max-w-360 rounded-xl bg-white px-6 py-8 shadow-[var(--shadow-xl)]">
        <div className="flex flex-col items-center text-center">
          <Skeleton className="mb-2.5 size-14 rounded-full" />
          <Skeleton className="mb-4 h-7 w-48 rounded-md" />
          <Skeleton className="h-14 w-full rounded-[var(--border-radius)]" />
          <Skeleton className="mt-4 h-4 w-56 rounded-md" />
        </div>
      </div>

      <div className="box-border flex w-full max-w-360 flex-col items-stretch gap-4 pt-6 text-center tablet:flex-row tablet:items-center tablet:justify-between">
        <div className="flex flex-col items-center gap-2 tablet:flex-row">
          <Skeleton className="size-12 shrink-0 rounded-full" />
          <div className="flex flex-col items-center gap-2 tablet:items-start">
            <Skeleton className="h-5 w-40 rounded-md" />
            <Skeleton className="h-4 w-48 rounded-md" />
          </div>
        </div>
        <Skeleton className="h-12 w-full shrink-0 rounded-md tablet:w-36" />
      </div>
    </div>
  );
};

export default LoginSkeleton;
